/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeSummaryAppliedVersion } from './scheduledChangeSummaryAppliedVersion';
import type { ScheduledChangeVisibleState } from './scheduledChangeVisibleState';
import type { ScheduledChangeSummaryGoLiveAt } from './scheduledChangeSummaryGoLiveAt';

export interface ScheduledChangeSummary {
  id: string;
  kind: string;
  moduleId: string;
  moduleTitle: string;
  version: string;
  appliedVersion?: ScheduledChangeSummaryAppliedVersion;
  state: ScheduledChangeVisibleState;
  goLiveAt?: ScheduledChangeSummaryGoLiveAt;
  stateChangedAt: string;
  questionCount: number;
}
